import { cn } from "@/lib/utils";
import React, { useState } from "react";
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetTitle,
} from "@/components/ui/sheet.tsx";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs.tsx";
import SettingsTabs from "@/components/SettingsSidepanel/SettingsTabs.tsx";
import { useUserContext } from "@/contexts/UserContextProvider.tsx";
import { CompanyRole, UserRole } from "@/__generated__/graphql";

const SETTINGS_SHEET_STYLES = {
  TABS: {
    trigger: "w-full text-left p-3 rounded-sm cursor-pointer",
  },
};

interface SettingsSidepanelProps {
  open: boolean;
  onClose: () => void;
}

const SettingsSheet: React.FC<SettingsSidepanelProps> = ({ open, onClose }) => {
  const [tabValue, setTabValue] = useState("account");
  const { currentUser, office } = useUserContext();

  return (
    <Sheet open={open} onOpenChange={onClose}>
      <SheetTitle className="sr-only">Settings Sheet</SheetTitle>
      <SheetDescription className="sr-only">
        Settings Sheet Description
      </SheetDescription>
      <SheetContent
        className={cn(
          "bg-primary z-50 m-3 max-h-full rounded-sm border-none p-0 min-w-1/2",
        )}
      >
        <Tabs
          value={tabValue}
          onValueChange={setTabValue}
          className="flex flex-1 flex-row overflow-hidden"
        >
          <TabsList className="text-secondary-foreground flex h-full w-1/5 flex-col rounded-none border-r bg-inherit p-5 text-base font-medium justify-start">
            <div className="flex h-full w-full flex-col space-y-2">
              <TabsTrigger
                className={cn(SETTINGS_SHEET_STYLES.TABS.trigger)}
                value="account"
              >
                Account
              </TabsTrigger>

              {currentUser?.role === UserRole.Admin &&
                office?.company.isAlertManagementDashboardEnabled &&
                office.company.role === CompanyRole.Client && (
                  <>
                    <TabsTrigger
                      className={cn(SETTINGS_SHEET_STYLES.TABS.trigger)}
                      value="users"
                    >
                      Users
                    </TabsTrigger>
                  </>
                )}

              {office?.company.role === CompanyRole.Client && (
                <TabsTrigger
                  className={cn(SETTINGS_SHEET_STYLES.TABS.trigger)}
                  value="integration"
                >
                  Integration
                </TabsTrigger>
              )}

              {(office?.company.role === CompanyRole.Vendor ||
                currentUser?.canBeAssignedTasks) && (
                <TabsTrigger
                  className={cn(SETTINGS_SHEET_STYLES.TABS.trigger)}
                  value="slapshot-integration"
                >
                  Slapshot Integration
                </TabsTrigger>
              )}
            </div>
          </TabsList>

          <div className="flex h-full w-4/5 overflow-y-auto">
            <SettingsTabs onRequestClose={onClose} />
          </div>
        </Tabs>
      </SheetContent>
    </Sheet>
  );
};

export default SettingsSheet;
